/** Pre-render a compact wireframe orbit sequence once; scrubbing only blits an image. */
export function createHeroSequence() {
  return Array.from({ length: 42 }, (_, frame) => {
    const canvas = document.createElement('canvas');
    canvas.width = 480;
    canvas.height = 280;
    const ctx = canvas.getContext('2d');
    if (!ctx) return canvas;
    const angle = frame / 41 * Math.PI * 0.65;
    ctx.translate(240, 140);
    for (let ring = 0; ring < 13; ring++) {
      ctx.beginPath();
      for (let point = 0; point <= 96; point++) {
        const theta = point / 96 * Math.PI * 2;
        const phi = ring / 13 * Math.PI;
        const x = Math.cos(theta) * 205;
        const y = Math.sin(theta) * Math.cos(phi) * 125;
        const z = Math.sin(theta) * Math.sin(phi) * 125;
        const rotatedX = x * Math.cos(angle) + z * Math.sin(angle);
        const rotatedZ = -x * Math.sin(angle) + z * Math.cos(angle);
        const perspective = 550 / (550 - rotatedZ);
        const px = rotatedX * perspective;
        const py = y * perspective;
        if (point === 0) ctx.moveTo(px, py);
        else ctx.lineTo(px, py);
      }
      ctx.strokeStyle = `rgba(137, 192, 216, ${0.12 + ring / 100})`;
      ctx.lineWidth = 0.65;
      ctx.stroke();
    }
    return canvas;
  });
}
